// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"9b38cbaa","429":"3b771f59","453":"1b5b352f","657":"ab7185b6"}[chunkId] + ".chunk.js";
};